import toast from 'react-hot-toast';

interface CustomToastProps {
  /**
   * The work to run. Whatever it resolves to is handed to `successMessage`
   * and returned by this helper, which is how callers know what was created.
   * Typed `void` originally, which was wrong — the implementation has always
   * captured and returned the value.
   */
  promise: () => Promise<any>;
  loadingMessage: any;
  successMessage: any;
  errorMessage?: any;
  onErrorCallBack?: Function;
}

//@ts-ignore
const CustomAsyncToast = ({
  promise,
  loadingMessage,
  successMessage,
  errorMessage,
  onErrorCallBack,
}: CustomToastProps) => {
  const toastStyle = {
    borderRadius: '10px',
    background: '#333',
    color: '#fff',
  };

  let result: any = null;
  return toast
    .promise(
      promise().then((r) => {
        result = r;
      }),
      {
        loading: loadingMessage,
        success: () => {
          return successMessage(result);
        },
        error: (r) => {
          onErrorCallBack?.(r);
          if (errorMessage) {
            return typeof errorMessage === 'function' ? errorMessage(r) : errorMessage;
          }
          if (typeof r === 'string' && r) return r;
          if (r?.message) return r.message;
          return 'Something went wrong';
        },
      },
      {
        style: toastStyle,
        duration: 10000,
      }
    )
    .then(() => {
      return result;
    });
};

export default CustomAsyncToast;
